import { SVGProps } from "react";
const PanelLongPostBoldSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" {...props}>
    <path
      fill="#2A2D31"
      fillRule="evenodd"
      d="M5 5.227A2.727 2.727 0 0 1 7.727 2.5h3.106a4.167 4.167 0 0 1 2.864 7.194 4.167 4.167 0 0 1-2.03 7.806H7.708A2.708 2.708 0 0 1 5 14.792V5.227Zm2.727-1.06h3.106a2.5 2.5 0 0 1 0 5H6.667v-3.94c0-.585.475-1.06 1.06-1.06Zm-1.06 6.666v3.959c0 .575.466 1.041 1.041 1.041h3.959a2.5 2.5 0 0 0 0-5h-5Z"
      clipRule="evenodd"
    />
  </svg>
);

const PanelLongPostItalicSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" {...props}>
    <path
      fill="#2A2D31"
      d="M11.684 2.5h2.065a.833.833 0 1 1 0 1.667h-1.432L9.4 15.833h1.433a.833.833 0 1 1 0 1.667H6.249a.833.833 0 1 1 0-1.667h1.433l2.917-11.666H9.166a.833.833 0 0 1 0-1.667h2.518Z"
    />
  </svg>
);

const PanelLongPostUnderlineSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" {...props}>
    <path
      fill="#2A2D31"
      fillRule="evenodd"
      d="M4.166 17.5c0-.46.373-.833.833-.833h10a.833.833 0 1 1 0 1.666H5a.833.833 0 0 1-.833-.833ZM5 1.667c.46 0 .833.373.833.833v6.667a4.167 4.167 0 1 0 8.333 0V2.5a.833.833 0 1 1 1.667 0v6.667a5.833 5.833 0 0 1-11.667 0V2.5c0-.46.373-.833.833-.833Z"
      clipRule="evenodd"
    />
  </svg>
);

const PanelLongPostAlignLeftSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
    <path
      fill="#2A2D31"
      fillRule="evenodd"
      d="M3 6a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1ZM3 10a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1ZM3 14a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1ZM3 18a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Z"
      clipRule="evenodd"
    />
  </svg>
);
//-
const PanelLongPostAlignCenterSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
    <path
      fill="#2A2D31"
      fillRule="evenodd"
      d="M3 6a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1ZM6 10a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1ZM3 14a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1ZM6 18a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1Z"
      clipRule="evenodd"
    />
  </svg>
);
//-
const PanelLongPostAlignRightSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
    <path
      fill="#2A2D31"
      fillRule="evenodd"
      d="M3 6a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1ZM9 10a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H10a1 1 0 0 1-1-1ZM3 14a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1ZM9 18a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H10a1 1 0 0 1-1-1Z"
      clipRule="evenodd"
    />
  </svg>
);

const PanelLongPostAlignJustify = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3 6C3 5.44772 3.44772 5 4 5H20C20.5523 5 21 5.44772 21 6C21 6.55228 20.5523 7 20 7H4C3.44772 7 3 6.55228 3 6Z"
      fill="#2A2D31"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3 10C3 9.44772 3.44772 9 4 9H20C20.5523 9 21 9.44772 21 10C21 10.5523 20.5523 11 20 11H4C3.44772 11 3 10.5523 3 10Z"
      fill="#2A2D31"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3 14C3 13.4477 3.44772 13 4 13H20C20.5523 13 21 13.4477 21 14C21 14.5523 20.5523 15 20 15H4C3.44772 15 3 14.5523 3 14Z"
      fill="#2A2D31"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3 18C3 17.4477 3.44772 17 4 17H20C20.5523 17 21 17.4477 21 18C21 18.5523 20.5523 19 20 19H4C3.44772 19 3 18.5523 3 18Z"
      fill="#2A2D31"
    />
  </svg>
);
export {
  PanelLongPostBoldSvg,
  PanelLongPostItalicSvg,
  PanelLongPostUnderlineSvg,
  PanelLongPostAlignLeftSvg,
  PanelLongPostAlignCenterSvg,
  PanelLongPostAlignRightSvg,
  PanelLongPostAlignJustify,
};
